export enum UserRole {
    ADMIN_OWNER = 'ROLE_ADMIN_OWNER',
    ADMIN_MEMBER = 'ROLE_ADMIN_MEMBER',
    MASTER_MEMBER = 'ROLE_MASTER_MEMBER',
    STANDARD_MEMBER = 'ROLE_STANDARD_MEMBER'
}
